export interface QCEngineParamsJSON {
  BBNSolver: number;
  OrderingRule: number;
  BDDConstructor: number;
}

export interface QCConstructorJSON {
  tree_id: number;
  replace_transfer_gates_with_basic_events: boolean;
}

export enum QCTypeParams {
  POINT_ESTIMATE = "point_estimate",
  POINT_ESTIMATE_AT_FIXED_TIME = "point_estimate_at_fixed_time",
  UNCERTAINTY = "uncertainty",
  UNCERTAINTY_AT_FIXED_TIME = "uncertainty_at_fixed_time",
  TIME_TO_FAILURE_CDF = "time_to_failure_cdf",
  TIME_TO_FAILURE_CDF_WITH_UNCERTAINTY = "time_to_failure_cdf_with_uncertainty",
}

export interface QCQuantifyImportanceParamsJSON {
  events: string;
  measures: string[];
}

export enum QCQuantifySamplingMethodsParams {
  MONTE_CARLO = "monte_carlo",
  LATIN_HYPERCUBE_RANDOM = "latin_hypercube_random",
  LATIN_HYPERCUBE_CENTER = "latin_hypercube_center",
  LATIN_HYPERCUBE_IMPROVED = "latin_hypercube_improved",
  QUASI_MONTE_CARLO_HALTON = "quasi_monte_carlo_halton",
  QUASI_MONTE_CARLO_FAURE = "quasi_monte_carlo_faure",
  QUASI_MONTE_CARLO_HAMMERSLEY = "quasi_monte_carlo_hammersley",
  MARKOV_CHAIN_MONTE_CARLO = "markov_chain_monte_carlo",
  MARKOV_CHAIN_QUASI_MONTE_CARLO = "markov_chain_quasi_monte_carlo",
}

export interface QCQuantifySamplingJSON {
  method: QCQuantifySamplingMethodsParams;
  number_of_samples: number;
  confidence_interval: number;
}

export interface QCQuantifyParamsJSON {
  type: QCTypeParams;
  mission_test_interval: number | null;
  user_defined_max_cutset: number;
  targets: string;
  sampling: QCQuantifySamplingJSON | {};
  importance?: QCQuantifyImportanceParamsJSON;
}

export interface QuantificationConfigurationJSON {
  constructor: QCConstructorJSON;
  quantify: QCQuantifyParamsJSON;
  engine: QCEngineParamsJSON;
}
